function p(p,f,t,u){p._m(f);var _=t("9f324490");p._(f,"AppRoutes",_),p._(f,"default",_,"App");}